<ng-container *ngIf="heatingCurve$ | async | ready as feature">
  <div class="flex flex-row flex-wrap gap-[30px]">
    <vi-item
      data-at-shift
      [title]="'+INSTALLATIONS.INSTALLATION.HEATING_ZONE.HEATING_CURVE.SHIFT' | translate"
      [valueSpecification]="feature | constraints: 'setCurve':'shift'"
      [asDropdown]="feature | executable: 'setCurve'"
      [value]="feature.properties?.shift?.value"
      (valueChange)="onShiftChange($event)"
    ></vi-item>
    <vi-item
      data-at-slope
      [title]="'+INSTALLATIONS.INSTALLATION.HEATING_ZONE.HEATING_CURVE.SLOPE' | translate"
      [valueSpecification]="feature | constraints: 'setCurve':'slope'"
      [asDropdown]="feature | executable: 'setCurve'"
      [value]="feature.properties?.slope?.value"
      [mantissaPlaces]="1"
      (valueChange)="onSlopeChange($event)"
    ></vi-item>
  </div>

  <app-heating-curve
    data-at-heating-curve
    *ngIf="feature?.properties?.slope && feature?.properties?.shift"
    [roomTemperature]="defaultRoomTemperature"
    [minFlowLimitTemperature]="minFlowLimitTemperature"
    [maxFlowLimitTemperature]="maxFlowLimitTemperature"
    [shift]="feature.properties?.shift?.value"
    [slope]="feature.properties?.slope?.value"
  ></app-heating-curve>
</ng-container>
